import React from 'react';
import classnames from 'classnames';
import { FormattedMessage } from 'react-intl';
import { useSelector } from 'react-redux';

import { Button } from 'ui-components/components/button';

import InvoicesGrid from './components/invoice-grid';
import HeaderRow from './components/invoice-header-row';
import InvoicesContextProvider from './invoices-context';
import { messages } from './messages';
import invoicesStyle from './style.module.less';
import ErrorBoundary from '../../../components/error-boundary';
import { HelpCenterService } from '../../../services/helpcenter-service';
import Global from '../../../store/global-selectors';
import style from '../../grid-page.module.less';

const InvoicesPage = () => {
  const country = useSelector(Global.selectSellerHomeCountry);
  return (
    <div className={invoicesStyle['grid-page']}>
      <div className={style['main-content']}>
        <div className={invoicesStyle['grid-header']}>
          <FormattedMessage {...messages.invoicesGridLabel} />
        </div>
        <div className={invoicesStyle['invoices-grid-description']}>
          <FormattedMessage {...messages.invoiceGridDescription} />
        </div>
        <div className={invoicesStyle['invoices-grid-support']}>
          <FormattedMessage
            {...messages.invoiceGridSupport}
            values={{
              a: (chunks) => (
                <Button
                  className={invoicesStyle['invoice-support-button']}
                  href={HelpCenterService.getHelpCenterUrl(country)}
                  target='_blank'
                  theme='link'
                >
                  {chunks}
                </Button>
              ),
            }}
          />
        </div>
        <div className={style['grid-content']}>
          <div className={classnames(style['grid-and-footer'], style['no-sidebar'])}>
            <div className={invoicesStyle.grid}>
              <ErrorBoundary errorMessageId='invoicesGrid'>
                <HeaderRow />
                <InvoicesGrid />
              </ErrorBoundary>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default () => {
  return (
    <InvoicesContextProvider>
      <InvoicesPage />
    </InvoicesContextProvider>
  );
};
